// ============================================
// src/components/Footer.jsx
// ============================================

import React from 'react';
import { Heart, Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" dir="rtl">
      <div className="footer-container">
        <div className="footer-grid">
          {/* About Section */}
          <div className="about-section">
            <div className="logo-container">
              <div className="logo-icon-wrapper">
                <Heart className="logo-icon" />
              </div>
              <h3 className="logo-text">عيادة الدكتوره باسمة جبر</h3>
            </div>
            <p className="about-description">
              استشارات طبية متخصصة ورعاية صحية شاملة لتقديم أفضل الخدمات الطبية
            </p>
            {/* باركود صغير */}
            <div className="barcode-section">
              <img 
                src="../../images/barcode.jpg" // قم بتغيير هذا المسار إلى صورة الباركود الخاصة بك
                alt="باركود التواصل"
                className="barcode-image"
              />
              <p className="barcode-text">امسح الباركود للتواصل</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="links-section">
            <h3 className="section-title">روابط سريعة</h3>
            <ul className="links-list">
              <li className="link-item">
                <Link to="/" className="footer-link">
                  الرئيسية
                </Link>
              </li>
              <li className="link-item">
                <Link to="/consultations" className="footer-link">
                  الاستشارات
                </Link>
              </li>
              <li className="link-item">
                <Link to="/articles" className="footer-link">
                  المقالات
                </Link>
              </li>
              <li className="link-item">
                <Link to="/dashboard" className="footer-link">
                  المواعيد
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="contact-section">
            <h3 className="section-title">تواصل معنا</h3>
            <ul className="contact-list">
              <li className="contact-item">
                <Mail className="contact-icon" />
                <a href="mailto:Gaaber1980@hotmail.com" className="contact-link">
                  Gaaber1980@hotmail.com
                </a>
              </li>
              <li className="contact-item">
                <Phone className="contact-icon" />
                <a href="tel:+971501166275" className="contact-link">
                   6275 116 50 971+
                </a>
              </li>
              <li className="contact-item">
                <Phone className="contact-icon" />
                <a href="tel:+971501166275" className="contact-link">
                  6275 116 50 971+
                </a>
              </li>
              <li className="contact-item">
                <MapPin className="contact-icon" />
                <span className="contact-text">
                  Saudi German Hospital Accommodation, Hessa Street, Dubai, 391093, UAE
                </span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="social-section">
            <h3 className="section-title">تابعنا على وسائل التواصل</h3>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/share/1CNTWfZnVJ/"
                className="social-link facebook"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook className="social-icon" />
                <span className="social-text">فيسبوك</span>
              </a>
              <a
                href="https://www.instagram.com/dr.basema.jaber?igsh=MTY3bzVrMm9hN3ZieA=="
                className="social-link instagram"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram className="social-icon" />
                <span className="social-text">إنستغرام</span>
              </a>
            </div>
            
            {/* Additional Info */}
            <div className="additional-info">
              <p className="info-text">استشارات طبية متوفرة:</p>
              <p className="info-text">- أيام الأحد إلى الخميس</p>
              <p className="info-text">- من 9:00 صباحاً إلى 5:00 مساءً</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="bottom-bar">
          <p>© {currentYear} عيادة الدكتوره باسمة جبر. جميع الحقوق محفوظة.</p>
          <p className="footer-note">مستشفى سعودي جيرمان، شارع حصة، دبي، الإمارات العربية المتحدة</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;